enum TextButtonTheme {
  BrightPurple = "BrightPurple",
  Error = "Error",
  Navy = "Navy",
  PopheadzDarkGray = "PopheadzDarkGray",
  Primary = "Primary",
  PurpleGradient = "PurpleGradient",
  Secondary = "Secondary",
  White = "White",
}

export default TextButtonTheme;
